import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { environment } from "src/environments/environment";

export type GagemGateway = {
	id: string;
	name: string;
	municipalities: {
		id: string;
		name: string;
	}[]
};

@Injectable({
	providedIn: 'root'
})
export class GagemService {
	private baseUrl: string = environment.gatewayURL;

	constructor(private http: HttpClient) {}

	getAll(): Observable<GagemGateway[]>{
		return this.http.post<{
			data: GagemGateway[]
		}>(`${this.baseUrl}/v1/gagem/all`, {}).pipe(
			map(response => response.data)
		);
	}
}